import React from 'react'
import { Link } from 'gatsby'
import { Row, Col } from 'react-bootstrap'
import { useLocation } from '@reach/router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/free-regular-svg-icons'
import { faCircle as faCircleSolid } from '@fortawesome/free-solid-svg-icons'

import './tabs_list.scss'

export const TabsList = ({ items }) => {
  const { pathname } = useLocation()

  return (
    <Row className="tabs-list">
      {items.map(({ path, label }) => {
        if (path === pathname) {
          return (
            <Col key={path} sm={6} md={3}>
              <Link className="tabs-list-item active" to={path}>
                <FontAwesomeIcon icon={faCircleSolid} />
                {label}
              </Link>
            </Col>
          )
        }

        return (
          <Col key={path} sm={6} md={3}>
            <Link className="tabs-list-item" to={path}>
              <FontAwesomeIcon icon={faCircle} />
              {label}
            </Link>
          </Col>
        )
      })}
    </Row>
  )
}
